<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Stock valorizado</h1>
          <p class="view-header__subtitle">Valor total del inventario según la lista de precios elegida.</p>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="row">
      <div class="col-12">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(valuedStockNumber) }}</div>
          <div class="stats-card__label">Valor total del stock</div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model="category_id" :options="categoryFilterOptions" placeholder="Todas las categorías" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="pricelist_id" :options="pricelistOptions" />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from 'vuex';

export default {
  components: {
    VdtnetTable,
    QSelect,
  },
  mixins: [formatMoneyMixin],
  data: function () {
    return {
      valuedStockNumber: 0,
      pricelist_id: 0,
      priceLists: [],
      category_id: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/stockvalued",
          type: "GET",
          data: (d) => {
            d.pricelist_id = this.pricelist_id;
            d.category_id = this.category_id;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 15,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        name: { label: "Nombre" },
        provname: { label: "Proveedor" },
        price: { label: "Precio", render: this.formatoDinamicoMoneda },
        stock: { label: "Cantidad" },
        total: { label: "Total", render: this.formatoDinamicoMoneda },
      },
    };
  },
  computed: {
    ...mapState('categories', {
      categories: state => state.categories,
    }),
    categoryFilterOptions() {
      return this.categories.map(cat => ({ value: cat.id, label: cat.name }));
    },
    pricelistOptions() {
      return [{ value: 0, label: 'Costo' }, ...this.priceLists.map(pl => ({ value: pl.id, label: pl.name }))];
    },
    filters() {
      return {
        pricelist_id: this.pricelist_id,
        category_id: this.category_id,
      };
    },
  },
  watch: {
    filters() {
      this.reload();
    },
  },
  created() {
    this.$store.dispatch('categories/getCategories');
  },
  mounted() {
    this.getValuedStockTotal();
    this.getPriceLists();
  },
  methods: {
    reload() {
      this.refreshTable();
      this.getValuedStockTotal();
    },
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    getValuedStockTotal() {
      this.$http.get(process.env.VUE_APP_BASE_URL + "/api/reports/stockvalued_number", {
        params: this.filters,
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }).then((response) => {
        this.valuedStockNumber = response.data.data;
      });
    },
    getPriceLists() {
      this.$http.get(process.env.VUE_APP_BASE_URL + "/api/priceslist/list").then((response) => {
        this.priceLists = response.data.data;
      });
    },
    exportCSV() {
      this.$http.post(process.env.VUE_APP_BASE_URL + "/api/reports/CSVStockValued", this.filters);
    },
    exportPDF() {
      this.$http.post(process.env.VUE_APP_BASE_URL + "/api/reports/PDFStockValued", this.filters);
    },
  },
};
</script>
